import type { Env } from '#/shared/lib/env-types'

export function getServerEnv(): Partial<Env> {
	return process.env as Partial<Env>
}
